import React from 'react';
import cn from 'classname';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';

const Pagination = ({pagination, gotoPage}) => {
	const neighborCount = 3;
	const currentPage = pagination.currentPage;

	let paginationPages = [];

	pagination.pages.forEach(pageIndex => {
		const page = ++pageIndex;
		if (page === 1 || page === pagination.pages.length) {
			paginationPages.push({
				number: page,
				active: page === pagination.currentPage
			});
			return;
		}
		if (Math.abs(page - currentPage) <= neighborCount) {
			paginationPages.push({
				number: page,
				active: page === pagination.currentPage
			});
			return;
		}
		if (!isNull(paginationPages[paginationPages.length - 1].number)) {
			paginationPages.push({
				number: null,
				active: false
			});
		}
	});
	return <div className="table-container__pagination">
		<div className="table-container__pagination-items">
			{ paginationPages.map((page, index) => {
				return (
					<a
						key={index}
						href="#"
						className={cn({
							'table-container__pagination-item': true,
							'active': page.active
						})}
						onClick={ e => {
							e.preventDefault();
							page.number && gotoPage(page.number);
						}}>{page.number ? page.number : '...'}</a>
				);
			}) }
		</div>
	</div>;
};

Pagination.propTypes = {
	gotoPage: PropTypes.func,
	pagination: PropTypes.object
};

export default Pagination;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/pagination.js